import { render } from "./DesktopBrands.vue?vue&type=template&id=0b56ad4c&scoped=true"
import script from "./DesktopBrands.vue?vue&type=script&lang=js"
export * from "./DesktopBrands.vue?vue&type=script&lang=js"

import "./DesktopBrands.vue?vue&type=style&index=0&id=0b56ad4c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b56ad4c"]])

export default __exports__